export * from "./atoms";
export * from "./molecules";
export * from "./organisms";

import { ProjectAtoms } from "./atoms";
import { ProjectMolecules } from "./molecules";
import { ProjectOrganisms } from "./organisms";

export const ProjectComponents = [...ProjectAtoms, ...ProjectMolecules, ProjectOrganisms];
